import React from 'react';

import { ListingCard } from '../../components';
import useVirtualTourAvailabilities from '../../components/listing/useVirtualTourAvailabilities';
import { FormattedMessage } from '../../util/reactIntl';

import css from './ListingPage.module.css';

const RELATED_CARD_SIZES = '(max-width: 767px) 90vw, (max-width: 1127px) 45vw, 260px';

const RelatedListings = ({ listings = [] }) => {
  const virtualTourAvailability = useVirtualTourAvailabilities(listings);

  if (!listings.length) {
    return null;
  }

  return (
    <section className={css.relatedListings} aria-labelledby="related-listings-heading">
      <h2 id="related-listings-heading">
        <FormattedMessage id="ListingPage.relatedListings" defaultMessage="Similar locations" />
      </h2>
      <div className={css.relatedListingsGrid}>
        {listings.map(listing => (
          <ListingCard
            key={listing.id.uuid}
            listing={listing}
            hasVirtualTour={virtualTourAvailability[listing.id.uuid] === true}
            renderSizes={RELATED_CARD_SIZES}
            setActiveListing={() => {}}
          />
        ))}
      </div>
    </section>
  );
};

export default RelatedListings;
